import { render, staticRenderFns } from "./InvoiceOverdue.vue?vue&type=template&id=ca3a5a44&"
import script from "./InvoiceOverdue.vue?vue&type=script&lang=ts&"
export * from "./InvoiceOverdue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca3a5a44')) {
      api.createRecord('ca3a5a44', component.options)
    } else {
      api.reload('ca3a5a44', component.options)
    }
    module.hot.accept("./InvoiceOverdue.vue?vue&type=template&id=ca3a5a44&", function () {
      api.rerender('ca3a5a44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Dashboard/InvoiceOverdue.vue"
export default component.exports